import { render, staticRenderFns } from "./column.vue?vue&type=template&id=fdb50e2c&scoped=true"
import script from "./column.vue?vue&type=script&lang=js"
export * from "./column.vue?vue&type=script&lang=js"
import style0 from "./column.vue?vue&type=style&index=0&id=fdb50e2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb50e2c",
  null
  
)

export default component.exports